export const emailOptions = {
    options: [
        'inline',
        // 'blockType',
        // 'fontSize',
        // 'fontFamily',
        'list',
        // 'textAlign',
        // 'colorPicker',
        // 'link',
        // 'embedded',
        'emoji',
        // 'image',
        'remove'
        // 'history'
    ],
    inline: {
        options: [
            'bold',
            'italic',
            'underline',
            'strikethrough'
            // 'monospace',
            // 'superscript',
            // 'subscript'
        ],
        bold: { className: 'rich-text-editor__toolbar__button' },
        italic: { className: 'rich-text-editor__toolbar__button' },
        underline: { className: 'rich-text-editor__toolbar__button' },
        strikethrough: { className: 'rich-text-editor__toolbar__button' }
        // monospace: { className: 'rich-text-editor__toolbar__button' },
        // superscript: { className: 'rich-text-editor__toolbar__button' },
        // subscript: { className: 'rich-text-editor__toolbar__button' }
    },
    list: {
        options: ['unordered', 'ordered'],
        unordered: { className: 'rich-text-editor__toolbar__button' },
        ordered: { className: 'rich-text-editor__toolbar__button' }
    },
    // link: {
    //   options: ['link', 'unlink'],
    //   link: { className: 'rich-text-editor__toolbar__button' },
    //   unlink: { className: 'rich-text-editor__toolbar__button' }
    // },
    emoji: { className: 'rich-text-editor__toolbar__button' },
    remove: { className: 'rich-text-editor__toolbar__button' }
    // history: {
    //   options: ['undo', 'redo'],
    //   undo: { className: 'rich-text-editor__toolbar__button' },
    //   redo: { className: 'rich-text-editor__toolbar__button' }
    // }
};
//# sourceMappingURL=email.js.map